import { BankOutlined, TeamOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import React from 'react'
import { ASSIGNEE_TYPE } from '../../../constants'
import selectPeopleStore from '../../../stores/selectPeopleStore'
import { AvatarHasName } from '../Avatar'
import { SelectList } from './SelectListComponentRiskStyled'

const SelectListComponentRisk = ({
  userList,
  originDepartmentWithUserList,
  style = {},
  status = '',
  convertCodeOrCodesToName,
}) => {
  const resultListUser = Array.isArray(originDepartmentWithUserList)
    ? originDepartmentWithUserList.flatMap(unit =>
        unit?.users
          ?.filter(userUnitsV2 =>
            userList?.some(
              itemUserList => itemUserList.id === userUnitsV2.user_name
            )
          )
          .map(userUnitsV2 => {
            const matchingUserList = userList.find(
              itemUserList => itemUserList.id === userUnitsV2.user_name
            )
            return {
              company_code: unit.company_code,
              user_code: userUnitsV2.user_code,
              full_name: userUnitsV2.name_uppercase,
              user_name: userUnitsV2.user_name,
              position_name:
                userUnitsV2.position_name ||
                (matchingUserList && matchingUserList.position_name) ||
                false,
            }
          })
      )
    : []

  const filteredResultListUser = resultListUser
    ? resultListUser.filter(
        (item, index, self) =>
          index === self.findIndex(t => t.user_code === item.user_code)
      )
    : []

  return (
    <SelectList style={{ marginBottom: 8, ...style }}>
      {filteredResultListUser?.length > 0
        ? filteredResultListUser?.map((item, index) => {
            const isDuplicate = userList?.some(
              (userListItem, userListIndex) =>
                userListIndex !== index && userListItem.id === item.id
            )
            return isDuplicate ? null : (
              <div key={index} style={{ marginTop: 4, height: '30px' }}>
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={item.id}
                  closable
                  onClose={() => selectPeopleStore.handleRemoveSelect(item)}>
                  <AvatarHasName
                    imgId={item.image_id}
                    size={22}
                    name={item.full_name}
                    icon={
                      (item.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                        <BankOutlined />
                      )) ||
                      (item.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      ))
                    }
                  />
                  {item?.position_name ? (
                    <>
                      <span style={{ fontWeight: 600 }}>
                        &nbsp;- {convertCodeOrCodesToName(item?.position_name)}
                      </span>
                    </>
                  ) : null}
                </Tag>
              </div>
            )
          })
        : userList?.map((item, index) => {
            const isDuplicate = resultListUser?.some(
              (resultListUserItem, resultListUserIndex) =>
                resultListUserIndex !== index &&
                resultListUserItem.id === item.id
            )
            return isDuplicate ? null : (
              <div key={index} style={{ marginTop: 4, height: '30px' }}>
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={item.id}
                  closable
                  onClose={() => selectPeopleStore.handleRemoveSelect(item)}>
                  <AvatarHasName
                    imgId={item.image_id}
                    size={22}
                    name={item.full_name}
                    icon={
                      (item.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                        <BankOutlined />
                      )) ||
                      (item.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      ))
                    }
                  />
                  {item?.position_name ? (
                    <>
                      <span style={{ fontWeight: 600 }}>
                        &nbsp;- {convertCodeOrCodesToName(item?.position_name)}
                      </span>
                    </>
                  ) : null}
                </Tag>
              </div>
            )
          })}
    </SelectList>
  )
}

export default SelectListComponentRisk
